import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './providers/AuthContext';

/**
 * Route wrapper that checks user role before rendering children.
 * Uses optimistic rendering - shows content immediately, redirects once role check completes.
 * Redirects to student dashboard if user lacks required role.
 */
export function RoleProtectedRoute({ children, allowedRoles = [] }) {
  const { user, loading, isSignedIn } = useAuth();
  const [redirectPath, setRedirectPath] = useState(null);

  useEffect(() => {
    if (!loading && isSignedIn) {
      const userRole = user?.role || 'student';
      if (!allowedRoles.includes(userRole)) {
        const studentId = user?.authing_user_id || user?.id;
        setRedirectPath(`/dashboard/${studentId}`);
      }
    }
  }, [loading, isSignedIn, user, allowedRoles]);

  if (redirectPath) {
    return <Navigate to={redirectPath} replace />;
  }

  return children;
}
